export enum CpxApiErrorCodeDmpConnectEnum {
    'TooManyPinCodeError' = 8,          // Trop d'essais de code PIN
}
